// Core clients and utils
export * from './apiClient';
export { authClient } from './authClient';
export { getStoredAccessToken } from './tokenStorage';
// The injection contract: `apiClient` above resolves to whatever a host published through
// `setApiClient`, falling back to `builtInApiClient`. See `types/onboardingApiClient.ts`.
export type { OnboardingApiClient } from './types/onboardingApiClient';

// API feature modules
export * from './assignedScreeners';
export * from './auth';
export * from './chat';
export * from './coachMatching';
export * from './eligibility';
export * from './healthConditions';
export * from './healthGoals';
export * from './inviteCode';
export * from './legalDocuments';
export * from './metricPoints';
export * from './mobileLink';
export * from './partners';
export * from './payingOrganization';
export * from './phqGad';
export * from './preDiabetes';
export * from './programs';
export * from './purl';
export * from './sesame';
export * from './stateCompliance';
export * from './teams';
export * from './user';
